import dayjs from 'dayjs'
import { ORDER_STATUSES } from './order-status'
import z from 'zod'

export const dayjsOrNull = z.preprocess(
    (arg) => {
        if (dayjs.isDayjs(arg)) {
            return arg.format()
        }
        return arg
    },
    z
        .string()
        .nullable()
        .transform((value) => (value ? dayjs(value) : null))
)

export const OrderStatusSchema = z.enum(ORDER_STATUSES)

export const UuidSchema = z.string()

export const geoCoordinatesSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
})

export const addressSchema = z.object({
    coordinates: geoCoordinatesSchema.optional(),
    country: z.string(),
    city: z.string(),
    street: z.string(),
    house_number: z.string().optional(),
    state: z.string().optional(),
    zip: z.string().optional(),
})

export const OrderFilterOptionSchema = z.object({
    uuid: UuidSchema,
    customer_asset_reference: z.string().optional(),
    address: addressSchema,
    valuation_date: z.string().optional(),
    order_date: z.string().optional(),
    status: OrderStatusSchema,
    customer_uuid: UuidSchema.optional(),
})
